import React, { useCallback } from "react";

import { useTranslation } from "@root/misc/useTranslation";

import {
  usePickerActionDispatch,
  usePickerStateSelector,
} from "../../context/pickerState";

import { useHandlePick } from "./Picker";

export const ConfirmDialog = () => {
  const { t } = useTranslation();

  const info = usePickerStateSelector((state) => state.showConfirmDialogue);

  const dispatch = usePickerActionDispatch();

  const handlePick = useHandlePick();

  const closeDialog = useCallback(() => {
    dispatch({ type: "CLOSE_CONFIRM_DIALOG" });
  }, [dispatch]);

  if (!info) {
    return null;
  }

  const { reason, prevPickBoughtFor, prevPickPriceNow, newlyPickedOption } = info;

  return (
    <div className="neo__lineupPicker__confirm__overlay">
      <div className="neo__lineupPicker__confirm__box">
        <div className="neo__lineupPicker__confirm__boxReason">
          <p>
            {t(
              `lineup_picker.reason.${reason}`,
              {
                price: t('type.pucks', { count: prevPickBoughtFor }),
                now: t('type.pucks', { count: prevPickPriceNow }),
              }
            )}
          </p>
        </div>
        <div className="neo__lineupPicker__confirm__boxActions">
          <a
            onClick={() =>
              handlePick(newlyPickedOption, {
                skipCheckConfirm: true,
              })
            }
          >
            {reason === "boughtForLessSoItsMaybeNotPossibleToReBuy"
              ? t("lineup_picker.confirm")
              : t("lineup_picker.ok")}
          </a>
          {reason === "boughtForLessSoItsMaybeNotPossibleToReBuy" && (
            <a onClick={closeDialog}>{t("lineup_picker.cancel")}</a>
          )}
        </div>
      </div>
    </div>
  );
};
